import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

@Composable
fun TournamentQualificationDraw(
    token: String?, tournamentId: String, rows: List<TournamentResultRow>, canEdit: Boolean, onReload: () -> Unit,
) {
    val ties = qualificationTies(rows)
    if (ties.isEmpty()) return
    H4 { Text("Los při úplné shodě") }
    P(attrs = { classes("muted") }) {
        Text("Hráči níže mají stejný součet i stejné jednotlivé náhozy. Zadejte jejich pořadí podle losu: 1 je první v dané shodě. Los se ukládá samostatně, bez změny náhozů.")
    }
    ties.forEach { tied ->
        key(tied.map { it.entry.id }) {
            QualificationDrawGroup(token, tournamentId, tied, canEdit, onReload)
        }
    }
}

@Composable
private fun QualificationDrawGroup(
    token: String?, tournamentId: String, tied: List<TournamentResultRow>, canEdit: Boolean, onReload: () -> Unit,
) {
    var ranks by remember(tied) { mutableStateOf(tied.associate { it.entry.id to (it.entry.qualRank?.toString() ?: "") }) }
    var busy by remember { mutableStateOf(false) }
    var error by remember { mutableStateOf<String?>(null) }
    val scope = rememberCoroutineScope()
    val values = ranks.values.map { it.toIntOrNull() }
    val valid = values.all { it != null && it in 1..tied.size } && values.distinct().size == tied.size
    Div(attrs = { classes("tournament-slot") }) {
        H5 { Text("${genderLabel(tied.first().entry.gender)} · součet ${tied.first().total} · náhozy ${tied.first().descendingScores.joinToString(", ")}") }
        Table(attrs = { classes("public-table") }) {
            Tr { Th { Text("Hráč") }; Th { Text("Pořadí podle losu") } }
            tied.forEach { row ->
                Tr {
                    Td { Text(row.entry.playerName) }
                    Td { Input(type = InputType.Text) {
                        classes("score-input"); attr("aria-label", "Los: ${row.entry.playerName}")
                        if (!canEdit || busy) disabled()
                        value(ranks[row.entry.id] ?: "")
                        onInput { ranks = ranks + (row.entry.id to it.value.filter(Char::isDigit).take(4)) }
                    } }
                }
            }
        }
        if (!valid) P(attrs = { classes("muted") }) { Text("Vyplňte každé pořadí 1 až ${tied.size} právě jednou.") }
        error?.let { P(attrs = { classes("editor-error") }) { Text(it) } }
        if (canEdit) Button(attrs = {
            if (busy || !valid) disabled()
            onClick {
                busy = true; error = null
                scope.launch {
                    try {
                        Api.saveTournamentQualificationDraw(token, tournamentId,
                            tied.map { QualificationDrawRank(it.entry.id, ranks.getValue(it.entry.id).toInt()) })
                        onReload()
                    } catch (e: Throwable) { error = "Uložení losu selhalo: ${e.apiMessage()}" }
                    busy = false
                }
            }
        }) { Text(if (busy) "Ukládám…" else "Uložit los") }
    }
}
